/**
 * OS constants
 */

export const PLATFORM = {
    DARWIN: "darwin",
    LINUX: "linux",
    WIN32: "win32",
    UNSUPPORTED: "unsupported",
} as const;
